/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Tools_Waypoints_TitleInputs */

const en_ui_studio_tools_waypoints_title = /** @type {(inputs: Ui_Studio_Tools_Waypoints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waypoints`)
};

const de_ui_studio_tools_waypoints_title = /** @type {(inputs: Ui_Studio_Tools_Waypoints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wegpunkte`)
};

/**
* | output |
* | --- |
* | "Waypoints" |
*
* @param {Ui_Studio_Tools_Waypoints_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_tools_waypoints_title = /** @type {((inputs?: Ui_Studio_Tools_Waypoints_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Tools_Waypoints_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_tools_waypoints_title(inputs)
	return de_ui_studio_tools_waypoints_title(inputs)
});